export const CUSTOM_DOMAIN_CAP = 50;

export const PLATFORM_ROOT_DOMAIN = "world-class.design";
export const NETLIFY_HOST_SUFFIX = ".netlify.app";

const LOCALHOST_HOSTS = new Set(["localhost", "127.0.0.1", "0.0.0.0"]);

export function isLocalhostHost(hostname: string): boolean {
  return LOCALHOST_HOSTS.has(hostname);
}

export function isPlatformHost(hostname: string): boolean {
  return (
    hostname === PLATFORM_ROOT_DOMAIN ||
    hostname.endsWith(`.${PLATFORM_ROOT_DOMAIN}`)
  );
}

export function isNetlifyHost(hostname: string): boolean {
  return hostname.endsWith(NETLIFY_HOST_SUFFIX);
}
